import React from 'react';
import './App.css';

// eslint-disable-next-line
import 'bootstrap/dist/css/bootstrap.min.css';

//Router
import { Switch, Route, MemoryRouter  } from 'react-router-dom/cjs/react-router-dom.min';

import Home from "./Pages/Home";
import AddReview from "./Pages/AddReview";
import ViewReview from "./Pages/ViewReview";


class App extends React.Component {

  render () {
    return (

      <MemoryRouter>
          <div className="App">
              <Switch>
                <Route exact path="/" component={Home}></Route>
                <Route path="/addreview" component={AddReview}></Route>
                <Route path="/viewreview" component={ViewReview}></Route>
              </Switch>
          </div>
      </MemoryRouter>
      
    )
  }
}

export default App;